<div class="row resource">
  <div class="col-2 p-0">
    <h6>Beamline</h6>
  </div>
  <div class="col-9">
    <div class="row">
      <div class="col-11">
        <h6>SCE Document</h6>
      </div>
      <div class="col-1 nowrap">
        <h6>Approval Date</h6>
      </div>
    </div>
  </div>
</div>
<div class="resource" *ngFor="let resource of resources" id="{{ resource.id }}">
  <div class="row">
    <div class="col-2">
      <h5 class="bold mb-2" [ngClass]="resource?.type == 1 ? 'blue' : 'green'">
        {{
          resource.displayName +
            (resource.displayName != resource.name
              ? " (" + resource.name + ")"
              : "")
        }}
      </h5>
    </div>
    <div class="col-9">
      <div class="row ml-2 mb-1" *ngFor="let sce of resource.sceLinks">
        <div class="col-11 p-0 bold">
          <a href="{{ sce.url }}" target="_blank"> {{ sce?.text }}</a>
        </div>
        <div class="col-1 p-0 nowrap">{{ sce.date | date : "M/d/yyyy" }}</div>
      </div>
    </div>
  </div>
</div>
